<template>
    <main-panel 
        class="info-of-institution">
        <template v-slot:header>
            <h2>{{$route.name}}</h2>
        </template>
        <div class="info-of-institution">
            <component 
                v-for = "item in skeleton" 
                :key="item" 
                :admin="admin"
                :is="item.component_name"
                :type-tols="item.component_name"
                :params="item.params"
                :header="item.header"
                :url="item.url"/> 
        </div>
    </main-panel>
</template>
<script>
import components from '@/mixins/components.mixin.js';
import mainPanel from '../components/main/mainPanel.vue'
import axios from 'axios';
export default{
    mixins:[components],
    components:{
        mainPanel,

    },
    mounted(){
        this.getSkeleton(this.$route.fullPath.substring(1))
        axios
            .get("https://mosp51.ru/api/login")
            .then(response=>{
                 console.log( response.data,'username')
                if (response.data.username){
                    this.admin = true
                } else {
                    this.admin = false
                }
            })
    },
    methods:{
      
    },
    data(){
        return {
            admin:false,
        }
    }
}
</script>
<style>
    .info-of-institution .main__institution__panel .panel:not(.panel__button){
        width: 100%;
    }
    .info-of-institution .panel h3,
    .info-of-institution .panel h4,
    .info-of-institution .panel p{
        font-size: 16px;
    }

    .info-of-institution section:last-child{
        margin-bottom: 100px;     
    }
    @media (max-width: 1000px){
        .info-of-institution .panel h3,
        .info-of-institution .panel h4,
        .info-of-institution .panel p{
            font-size: 14px;
        }

    }
</style>